module.exports = __webpack_public_path__ + "static/img/mp3.4e919f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_suffix/mp3.png
// module id = Be1G
// module chunks = 53